import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, pricing } from '../data/landing';
type PriceCardProps = {
  subtitle: string;
  idealFor?: string;
  ctaLabel: string;
  currentPrice?: string;
  title?: string;
  originalPrice?: string;
  badge?: string;
};
export function PriceCard({
  subtitle,
  idealFor,
  ctaLabel,
  currentPrice = pricing.current,
  title = 'MegaPack Dopamina Cero',
  originalPrice = pricing.original,
  badge = 'Precio de lanzamiento'
}: PriceCardProps) {
  return <div className="relative mx-auto w-full max-w-2xl rounded-3xl border border-accent/40 bg-surface p-7 text-center shadow-2xl shadow-black/40 md:p-10" data-id="element-28" data-mp="31fdaln0h73gi">
      <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-line bg-ink px-4 py-1.5 text-xs font-black uppercase tracking-wider text-heading" data-id="element-29" data-mp="2rh5xjf9b55js">
        {badge}
      </span>
      <BookOpenIcon className="mx-auto h-9 w-9 text-success" aria-hidden="true" data-id="element-30" data-mp="1g3lcx1eb0xh5" />
      <h3 className="mt-3 text-2xl font-black uppercase leading-tight text-heading md:text-3xl" data-id="element-31" data-mp="3kn48xym6n58f">
        {title}
      </h3>
      <p className="mt-2 text-base font-semibold text-heading/90 md:text-lg" data-id="element-32" data-mp="3fokndzbi3vgl">{subtitle}</p>
      {idealFor && <p className="mt-3 text-sm text-body" data-id="element-33" data-mp="3to2fank3fou6">
          <span className="font-bold text-heading" data-id="element-34" data-mp="3onxzkzr0ey50">Ideal para:</span> {idealFor}
        </p>}
      <div className="mt-6 flex flex-col items-center" data-id="element-35" data-mp="7faxy6ujvt26">
        <span className="text-xl font-semibold text-body line-through decoration-danger decoration-2" data-id="element-36" data-mp="7dzrfz9q077d">
          {originalPrice}
        </span>
        <span className="mt-2 flex items-baseline justify-center gap-2 rounded-2xl border border-line bg-ink px-5 py-2" style={{
        minWidth: "284px",
        height: "63px"
      }} data-id="element-37" data-mp="g7modspnzgi5">
          <span className="whitespace-nowrap text-6xl font-black tracking-tight text-accent md:text-7xl" style={{
          fontSize: "48px"
        }} data-id="element-38" data-mp="q624l0n5l5cv">
            {currentPrice}
          </span>
          <span className="text-lg font-bold text-heading" data-id="element-39" data-mp="3eyxk6q2bpk32">{pricing.currency}</span>
        </span>
      </div>
      <div className="mt-7 flex justify-center" data-id="element-40" data-mp="3j09br14rcfdw">
        <CtaButton href={checkoutUrl} data-id="element-41" data-mp="3j129jclqnujw">{ctaLabel}</CtaButton>
      </div>
    </div>;
}